var $ef7bd3c74b9d000a$exports = {};
(function() {
    'use strict';
    window.applySmoothScroll = {
        bind: bindSmoothScroll,
        scrollTo: smoothScrollTo
    };
    function bindSmoothScroll(root) {
        if (!root || root._applyEventsBound) return;
        root.addEventListener('click', function(event) {
            handleAnchorClick(event, root);
        });
        root._applyEventsBound = true;
    }
    function smoothScrollTo(top, duration) {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            window.scrollTo(0, top);
            return;
        }
        var startY = window.pageYOffset;
        var diff = top - startY;
        var startTime = performance.now();
        var total = Math.max(0, duration || 350);
        function step(now) {
            var t = Math.min(1, (now - startTime) / total);
            var eased = 0.5 - Math.cos(Math.PI * t) / 2;
            window.scrollTo(0, startY + diff * eased);
            if (t < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
    }
    function handleAnchorClick(event, root) {
        var anchor = event.target && event.target.closest('a[href^="#"]');
        if (!anchor || !root || !root.contains(anchor)) return;
        var id = anchor.getAttribute('href');
        if (!id || id.length <= 1) return;
        var target = document.querySelector(id);
        if (!target) return;
        event.preventDefault();
        var top = target.getBoundingClientRect().top + window.pageYOffset - 16;
        smoothScrollTo(top, 350);
    }
})();


//# sourceMappingURL=smooth-scroll.js.map
